import axios from "axios";

import { ACTION_TYPES } from "./constants";

const baseUrl = process.env.REACT_APP_API_URL;

const config = {
  headers: { Authorization: '' },
};

const getFileAction = (fileId) => async () => {

  if (!fileId) {
    return;
  }

  try {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    const res = await axios.get(`${baseUrl}/files/${fileId}`, config);
    return res.data?.data || {};
  } catch (error) {
    console.log(error);
  }
};

export const getFileActionWithRetry = (fileId, retry = 0) => async (dispatch) => {
  if (retry === 5) return null;
  try {
    const { signedUrl } = await dispatch(getFileAction(fileId));
    dispatch({
      type: ACTION_TYPES.GET_FILE_DOWNLOAD_SIGNED_URL_REQUEST_SUCCESS,
      payload: {
        fileId,
        signedUrl
      }
    });
    return { signedUrl };
  } catch (e) {
    await new Promise(res => setTimeout(() => res(), 500));
    return await dispatch(getFileActionWithRetry(fileId, retry + 1));
  }
};
